var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"texts"},[_vm._v("未报名成功或活动未审核前无法查看")])}
var staticRenderFns = []

export { render, staticRenderFns }